import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { LoadingIcon } from "../../../themes/userq/Loader/loadingIcon";
import { Button } from "../Button/Button";
import { CheckBox } from "../CheckBox/CheckBox";
import { Icon } from "../Icon/Icon";
import { Text } from "../Text/Text";

export default function ReportTesterConfirmation({
    openModal,
    total_test,
    confirm_title,
    confirm_btn_title,
    cancel_btn_title,
    close,
    confirm,
    btnLoading,
    confirm_title_class,
    cssClass,
    confirm_btn_disabled,
    confirm_btn_loading,
    report_type,
    testers,
}) {
    const closeModal = () => {
        close();
    };
    const wrapperRef = useRef(null);

    const navigate = useNavigate();

    function useOutsideAlerter(ref) {
        useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    if (event.target.nodeName == "DIV") {
                        closeModal();
                    }
                }
            }
            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(wrapperRef);

    return (
        <Modal
            show={openModal}
            centered
            className={`fade custom-modal-wrap  confirmation-modal-wrap report-tester-confirmation-modal ${cssClass}`}
        >
            <Modal.Body className="" ref={wrapperRef}>
                {btnLoading ? (
                    <div className="modal-loader text-center">
                        <LoadingIcon />
                    </div>
                ) : (
                    <div className="modal-inner-text">
                        <div className="modal-header-top mb-20">
                            <Text type={"h3"}>{confirm_title}</Text>

                            <button
                                type="button"
                                className="close"
                                onClick={() => {
                                    closeModal();
                                }}
                                aria-label="Close"
                            >
                                <span aria-hidden="true">
                                    <Icon
                                        value="Close"
                                        size="medium"
                                        hover={true}
                                    />
                                </span>
                            </button>
                        </div>

                        <div className={"report-tester-confirmation-data-wrap"}>
                            <div className="d-flex">
                                <Icon
                                    size={"medium"}
                                    value={"under-review-pink"}
                                    cssClasses={"mr-12"}
                                />
                                <Text
                                    type={"body-text-2"}
                                    cssClasses={"tester-selected-data mb-0"}
                                    fontWeight={"semi-bold-font"}
                                >
                                    Your reported participants will be sent to our team for review.
                                </Text>
                            </div>
                            {report_type == "Report and recruit" && (
                                <div className="d-flex mt-12">
                                    <Icon
                                        size={"medium"}
                                        value={"success"}
                                        cssClasses={"mr-12"}
                                    />
                                    <Text
                                        type={"body-text-2"}
                                        cssClasses={" mb-0"}
                                        fontWeight={"semi-bold-font"}
                                    >
                                        Additional {testers} {testers === 1 ? " participant" : " participants"} will be recruited.
                                    </Text>
                                </div>
                            )}
                            <div className="mt-20">
                                <Text
                                    type={"body-text-3"}
                                    fontWeight={"semi-bold-font"}
                                    cssClasses={"mb-8"}
                                >
                                    Are you sure you want to submit your
                                    request?
                                </Text>
                                <Text
                                    type={"body-text-3"}
                                    fontWeight={"medium-font"}
                                    cssClasses={"gray-text "}
                                >
                                    Once the process is complete, you will receive an email notification and credits will be refunded to your wallet for approved requests. The reported participants results will be hidden from your test report.
                                </Text>
                            </div>
                            <div className="mt-20">
                                <Text
                                    type={"body-text-3"}
                                    fontWeight={"medium-font"}
                                    cssClasses={"gray-text"}
                                >
                                    Please note that:
                                </Text>
                                <ul className="gray-text pl-4 mb-0">
                                    <li>
                                        <Text
                                            type={"body-text-3"}
                                            fontWeight={"medium-font"}
                                            cssClasses={"gray-text"}
                                        >
                                            You can only submit a request once per test.
                                        </Text>
                                    </li>
                                    <li>
                                        <Text
                                            type={"body-text-3"}
                                            fontWeight={"medium-font"}
                                            cssClasses={"gray-text"}
                                        >
                                            Only testers recruited via UserQ can be reported (not those who joined via shared link)
                                        </Text>
                                    </li>
                                    {/*<li>
                                        <Text
                                            type={"body-text-3"}
                                            fontWeight={"medium-font"}
                                            cssClasses={"gray-text"}
                                        >
                                            For the approved requests, results
                                            will be hidden from the test report.
                                        </Text>
                                    </li>*/}
                                </ul>
                            </div>
                        </div>

                        <div className="confirm-buttons-wrap mt-20">
                            <Button
                                type="secondary"
                                size="large"
                                label={
                                    cancel_btn_title
                                        ? cancel_btn_title
                                        : "Cancel"
                                }
                                onClick={() => {
                                    closeModal();
                                }}
                            />

                            <Button
                                type="primary"
                                microLoading={
                                    confirm_btn_loading
                                        ? confirm_btn_loading
                                        : false
                                }
                                size="large"
                                state={
                                    confirm_btn_disabled
                                        ? confirm_btn_disabled
                                        : "active"
                                }
                                label={
                                    confirm_btn_title ? confirm_btn_title : "OK"
                                }
                                onClick={() => {
                                    confirm();
                                }}
                            />
                        </div>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
}
